export enum TCurrency {
  ETHER = 'ETH',
  WEI = 'WEI'
}
